import React from "react";

const Kotlin_Compiler = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Compiler</h1>
      <p>Content for Kotlin Compiler goes here.</p>
    </div>
  );
};

export default Kotlin_Compiler;
